<div class="header-wrapper">
  <ng-content></ng-content>
</div>
